import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmationComponent implements OnInit {
  confirmationSuccess: boolean;
  confirmationTitle: string;
  confirmationMessage: string;

  constructor(
    private readonly activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  private closeActiveModal() {
    this.activeModal.dismiss();
  }
  onCancelClick() {
    this.closeActiveModal();
  }

}
